import { Extension } from "@tiptap/core"
import { marked } from "marked"
import { Plugin, PluginKey } from "prosemirror-state"

export const RichTextMarkdownPaste = Extension.create({
  name: "markdownPaste",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("markdownPaste"),
        props: {
          handlePaste: (_, event) => {
            const clipboardText = event.clipboardData?.getData("text/plain")
            if (clipboardText) {
              const html = marked(clipboardText)
              if (html && typeof html === "string") {
                // Remove starting and ending <p> tags only if there's exactly one <p> tag
                const pTagCount = (html.match(/<p>/g) || []).length
                const cleanedHtml = pTagCount === 1 ? html.replace(/^\s*<p>|<\/p>\s*$/g, "").trim() : html
                const formattedHtml = cleanedHtml
                  .split("\n")
                  .map((p) => (p.indexOf("<") === 0 ? p : `<p>${p}</p>`))
                  .join("")

                this.editor.commands.insertContent(formattedHtml)
                return true
              }
            }

            return false
          },
        },
      }),
    ]
  },
})
